export default function Custom404() {
  return (
    <h1
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'Montserrat',
      }}
    >
      404 - Page Not Found!
    </h1>
  );
}
